import { Tooltip } from "@blueprintjs/core";
import React, { PropsWithChildren } from "react";
import "./Tooltip.scss";

export const ScenarioLimitTooltip: React.FC<
    PropsWithChildren<{
        isAtScenarioLimit: boolean;
    }>
> = ({ isAtScenarioLimit, children }) => {
    return (
        <Tooltip
            content="You have reached the scenario limit for this subscription."
            position="bottom"
            className="tooltip"
            disabled={!isAtScenarioLimit}
        >
            {children}
        </Tooltip>
    );
};
